import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Goals from "@/pages/Goals";
import DailyTracker from "@/pages/DailyTracker";
import SurgeryLog from "@/pages/SurgeryLog";
import SOPLibrary from "@/pages/SOPLibrary";
import Training from "@/pages/Training";
import Incentives from "@/pages/Incentives";
import BranchComparison from "@/pages/BranchComparison";
import Scorecard from "@/pages/Scorecard";
import OwnerFeedback from "@/pages/OwnerFeedback";
import MasterList from "@/pages/MasterList";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useApp();
  if (loading) return <div className="h-screen flex items-center justify-center bg-[#0b1120] text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/goals" element={<Goals />} />
        <Route path="/daily-tracker" element={<DailyTracker />} />
        <Route path="/surgery-log" element={<SurgeryLog />} />
        <Route path="/sop-library" element={<SOPLibrary />} />
        <Route path="/training" element={<Training />} />
        <Route path="/incentives" element={<Incentives />} />
        <Route path="/branch-comparison" element={<BranchComparison />} />
        <Route path="/scorecard" element={<Scorecard />} />
        <Route path="/owner-feedback" element={<OwnerFeedback />} />
        <Route path="/master-list" element={<MasterList />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" theme="dark" />
      </BrowserRouter>
    </AppProvider>
  );
}
